var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HostGeneralInfoService } from './host-general-info.service';
import { ImsService } from '../../ims.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { resolveDomainValidationErrorMessage } from 'src/app/shared/domain-validation/domain-validation-messages';
var IMAGES = {
    vehicle: '/assets/svgImages/vehicle.svg',
};
var HOST_PROFILE_TYPE = 'host';
var HostGeneralInfoComponent = /** @class */ (function () {
    function HostGeneralInfoComponent(dialog, hostGeneralInfoService, imsService, toasterService, datePipe) {
        this.dialog = dialog;
        this.hostGeneralInfoService = hostGeneralInfoService;
        this.imsService = imsService;
        this.toasterService = toasterService;
        this.datePipe = datePipe;
        this.info = {};
        this.referralSummary = {};
        this.hoprMetrics = null;
        this.showEmailDialog = false;
        this.showDeleteEmailDialog = false;
        this.newEmail = '';
        this.updatingEmail = false;
        this.deletingEmail = false;
        this.errorMsg = '';
        this.domainType = '';
        this.domainTypeLookupLoading = false;
        this.domainTypeOptions = ['corporate', 'non_corporate'];
        this.deleteErrorMsg = '';
        this.showNameDialog = false;
        this.newName = '';
        this.updatingName = false;
        this.nameErrorMsg = '';
    }
    HostGeneralInfoComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            if (this.data.dataFetched) {
                this.getHostVehicleDetail(function () {
                    _this.constructCard();
                });
            }
            else {
                this.blankCard();
            }
        }
        else {
            this.emptyCard();
        }
    };
    HostGeneralInfoComponent.prototype.ngOnInit = function () { };
    HostGeneralInfoComponent.prototype.blankCard = function () {
        this.info = {
            header: 'General Info',
            data: [],
            dataFetched: false
        };
    };
    HostGeneralInfoComponent.prototype.emptyCard = function () {
        this.info = {
            header: 'General Info',
            dataFetched: false,
            data: null
        };
    };
    HostGeneralInfoComponent.prototype.constructCard = function () {
        if (this.data && this.data.dataFetched) {
            var hostProfileData = this.data.profiles.filter(function (profile) { return profile.type === HOST_PROFILE_TYPE; })[0];
            if (!hostProfileData) {
                this.blankCard();
                return;
            }
            var selectedVehicle = this.vehicleDetails.selectedVehicle || this.vehicleDetails.vehicleData;
            var vehicleNumber = selectedVehicle ? (selectedVehicle.number || 'N/A') : 'N/A';
            var vehicleName = selectedVehicle && selectedVehicle.info
                ? ((selectedVehicle.info.manufacturer || '') + ' ' + (selectedVehicle.info.model || '')).trim() || 'N/A'
                : 'N/A';
            var vehicleTypeDisplayName = this.vehicleDetails.vehicleTypeDisplayName || 'N/A';
            this.info = {
                header: 'General Info',
                dataFetched: true,
                data: [
                    {
                        header: 'Name',
                        value: this.data.name,
                        className: 'id-icon',
                        svgIcon: true,
                        actionMenuItems: [
                            { label: 'Edit Name', event: 'Edit Name' }
                        ]
                    },
                    { header: 'Gender', value: this.data.gender, className: 'id-icon', svgIcon: true },
                    {
                        header: 'Email',
                        value: hostProfileData.email,
                        className: 'email-id-icon',
                        svgIcon: true,
                        actionMenuItems: this.getEmailActionMenuItems(hostProfileData.email)
                    },
                    { header: 'Vehicle Number', value: vehicleNumber, svgIcon: true, className: 'email-id-icon' },
                    { header: 'Vehicle Name', value: vehicleName, svgIcon: true, className: 'email-id-icon' },
                    { header: 'Vehicle Type', value: vehicleTypeDisplayName, svgIcon: true, className: 'email-id-icon' },
                    { header: 'LTR', value: this.getLtrValue(), svgIcon: true, className: 'id-icon' }
                ].concat((this.referralSummary.myReferralCode ? [{ header: 'My Referral Code', value: this.referralSummary.myReferralCode, svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredBy && this.referralSummary.referredBy.name ? [__assign({ header: 'Referred By', value: this.referralSummary.referredBy.mobile ? this.referralSummary.referredBy.name + " (" + this.referralSummary.referredBy.mobile + ")" : this.referralSummary.referredBy.name, svgIcon: true, className: 'referral-code-icon' }, (this.referralSummary.referredBy.role && this.referralSummary.referredBy.mobile ? { redirectLink: "/" + this.referralSummary.referredBy.role.toLowerCase() + "/" + this.referralSummary.referredBy.mobile } : {}))] : []), (this.referralSummary.referredBy && this.referralSummary.referredBy.code ? [{ header: 'Referred By Code', value: this.referralSummary.referredBy.code, svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredAt ? [{ header: 'Referred At', value: this.formatDate(this.referralSummary.referredAt), svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredRewardAchievedAt ? [{ header: 'Referral Reward At', value: this.formatDate(this.referralSummary.referredRewardAchievedAt), svgIcon: true, className: 'referral-code-icon' }] : []))
            };
        }
    };
    HostGeneralInfoComponent.prototype.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
                return temp.substring(name.length, temp.length);
            }
        }
        return '';
    };
    HostGeneralInfoComponent.prototype.getHostVehicleDetail = function (callback) {
        var _this = this;
        var hostProfile = this.data.profiles.filter(function (profile) { return profile.type === HOST_PROFILE_TYPE; })[0];
        if (!hostProfile) {
            this.blankCard();
            return;
        }
        var hostProfileId = hostProfile.id;
        var completedCount = 0;
        var totalCalls = 3;
        var checkComplete = function () {
            completedCount++;
            if (completedCount === totalCalls) {
                callback();
            }
        };
        this.hostGeneralInfoService.getHostVehicleDetails(hostProfileId).subscribe(function (result) {
            if (result && result.hosts.length > 0) {
                _this.vehicleDetails = result.hosts[0];
                _this.vehicleDetails.dataFetched = true;
            }
            else {
                _this.vehicleDetails = { dataFetched: false };
            }
            checkComplete();
        }, function (error) {
            console.error('Error fetching host vehicle details:', error);
            _this.vehicleDetails = { dataFetched: false };
            checkComplete();
        });
        this.hostGeneralInfoService.getReferralSummary(hostProfileId).subscribe(function (result) {
            _this.referralSummary = result || {};
            checkComplete();
        }, function (error) {
            console.error('Error fetching referral summary:', error);
            _this.referralSummary = {};
            checkComplete();
        });
        this.hostGeneralInfoService.getHoprMetrics(hostProfileId).subscribe(function (result) {
            _this.hoprMetrics = result || null;
            checkComplete();
        }, function (error) {
            console.error('Error fetching HOPR metrics:', error);
            _this.hoprMetrics = null;
            checkComplete();
        });
    };
    HostGeneralInfoComponent.prototype.formatDate = function (dateStr) {
        if (!dateStr) {
            return 'N/A';
        }
        return this.datePipe.transform(dateStr, 'mediumDate') || 'N/A';
    };
    HostGeneralInfoComponent.prototype.getLtrValue = function () {
        var metrics = this.hoprMetrics && this.hoprMetrics.data
            ? this.hoprMetrics.data
            : this.hoprMetrics;
        var netRides = metrics
            && metrics.lifeTimeRideBehaviour
            && metrics.lifeTimeRideBehaviour.netRides;
        if (typeof netRides === 'number') {
            return String(netRides);
        }
        return 'N/A';
    };
    HostGeneralInfoComponent.prototype.getEmailActionMenuItems = function (email) {
        var menuItems = [{ label: 'Edit Email', event: 'Edit Email' }];
        if (email) {
            menuItems.push({ label: 'Delete Email', event: 'Delete Email' });
        }
        return menuItems;
    };
    HostGeneralInfoComponent.prototype.eventTriggered = function (value) {
        if (value === 'Edit Email') {
            this.errorMsg = '';
            this.newEmail = '';
            this.resetDomainTypeSelection();
            this.showEmailDialog = true;
        }
        else if (value === 'Delete Email') {
            this.deleteErrorMsg = '';
            this.showDeleteEmailDialog = true;
        }
        else if (value === 'Edit Name') {
            this.nameErrorMsg = '';
            this.newName = '';
            this.showNameDialog = true;
        }
    };
    HostGeneralInfoComponent.prototype.closeEmailDialog = function () {
        if (this.updatingEmail) {
            return;
        }
        this.showEmailDialog = false;
        this.newEmail = '';
        this.resetDomainTypeSelection();
        this.errorMsg = '';
    };
    HostGeneralInfoComponent.prototype.resetDomainTypeSelection = function () {
        this.domainType = '';
        this.domainTypeLookupLoading = false;
    };
    HostGeneralInfoComponent.prototype.canLookupEmail = function () {
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        return trimmedEmail.indexOf('@') > 0;
    };
    HostGeneralInfoComponent.prototype.lookupEmailDomain = function () {
        var _this = this;
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!trimmedEmail || trimmedEmail.indexOf('@') <= 0) {
            this.resetDomainTypeSelection();
            return;
        }
        this.domainTypeLookupLoading = true;
        this.imsService.lookupEmailDomain(trimmedEmail).subscribe({
            next: function (response) {
                _this.domainTypeLookupLoading = false;
                if (response && response.exists && response.domainType) {
                    _this.domainType = response.domainType;
                }
                else {
                    _this.domainType = '';
                }
            },
            error: function () {
                _this.domainTypeLookupLoading = false;
                _this.domainType = '';
            }
        });
    };
    HostGeneralInfoComponent.prototype.submitEmail = function () {
        var _this = this;
        if (!this.data || !this.data.profiles) {
            return;
        }
        var hostProfile = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
        var normalizedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!hostProfile || !normalizedEmail) {
            this.errorMsg = 'Please enter a valid email.';
            return;
        }
        if (!this.domainType) {
            this.errorMsg = 'Please select a domain type.';
            return;
        }
        this.updatingEmail = true;
        this.errorMsg = '';
        this.imsService.updateUserEmail(this.data.id, normalizedEmail, [HOST_PROFILE_TYPE], this.domainType).subscribe({
            next: function () {
                hostProfile.email = normalizedEmail;
                _this.constructCard();
                _this.showEmailDialog = false;
                _this.newEmail = '';
                _this.updatingEmail = false;
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Email updated successfully.'
                }));
            },
            error: function (err) {
                _this.updatingEmail = false;
                _this.errorMsg = resolveDomainValidationErrorMessage(err);
            }
        });
    };
    HostGeneralInfoComponent.prototype.closeDeleteEmailDialog = function () {
        if (this.deletingEmail) {
            return;
        }
        this.showDeleteEmailDialog = false;
        this.deleteErrorMsg = '';
    };
    HostGeneralInfoComponent.prototype.deleteEmail = function () {
        var _this = this;
        if (!this.data || !this.data.id) {
            return;
        }
        this.deletingEmail = true;
        this.deleteErrorMsg = '';
        this.imsService.deleteUserEmail(this.data.id).subscribe({
            next: function () {
                _this.showDeleteEmailDialog = false;
                _this.deletingEmail = false;
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Email deleted successfully.'
                }));
                window.location.reload();
            },
            error: function (err) {
                _this.deletingEmail = false;
                _this.deleteErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to delete email';
            }
        });
    };
    HostGeneralInfoComponent.prototype.closeNameDialog = function () {
        if (this.updatingName) {
            return;
        }
        this.showNameDialog = false;
        this.newName = '';
        this.nameErrorMsg = '';
    };
    HostGeneralInfoComponent.prototype.submitName = function () {
        var _this = this;
        if (!this.data) {
            return;
        }
        if (!this.newName || !this.newName.trim()) {
            this.nameErrorMsg = 'Please enter a valid name.';
            return;
        }
        this.updatingName = true;
        this.nameErrorMsg = '';
        this.imsService.updateUserName(this.data.id, this.newName.trim()).subscribe({
            next: function () {
                _this.data.name = _this.newName.trim();
                _this.constructCard();
                _this.showNameDialog = false;
                _this.newName = '';
                _this.updatingName = false;
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Name updated successfully.'
                }));
            },
            error: function (err) {
                _this.updatingName = false;
                _this.nameErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to update name';
            }
        });
    };
    return HostGeneralInfoComponent;
}());
export { HostGeneralInfoComponent };
